import type { OptionInterface } from '~/components/base/controls/use-input'

export function toAutocomplete(data: {
  name: string
  id: number | string | undefined
}): OptionInterface {
  return {
    value: data.id,
    label: data.name,
  }
}
